export interface RTPProfileFormValues {
    versionString: string;
    versionNumber: string;
    aggregatorString: string;
    rtp: string;
}

export interface RTPProfileDefaultsFormValues {
    defaultSubsidiaries: number[];
}

export interface RTPProfilePayload {
    version_string: string;
    version_number: number;
    aggregator_string: string;
    rtp: string;
}

export const EMPTY_RTP_PROFILE_FORM: RTPProfileFormValues = {
    versionString: "V",
    versionNumber: "",
    aggregatorString: "=",
    rtp: ""
};

export const EMPTY_RTP_PROFILE_DEFAULTS_FORM: RTPProfileDefaultsFormValues = {
    defaultSubsidiaries: []
};

export const rtpInputValue = value =>
    value === undefined || value === null
        ? ""
        : String(value).trim().replace(/%$/, "");

export const formatRTP = value => {
    if (value === undefined || value === null || String(value).trim() === "") {
        return "-";
    }

    const normalized = String(value).trim();
    return /^\d+$/.test(normalized) ? `${normalized}%` : normalized;
};

export const profileString = profile =>
    `${profile.version_string}${profile.version_number}${
        profile.aggregator_string
    }${formatRTP(profile.rtp)}`;

export const profileFormValues = profile => ({
    versionString: profile.version_string || "V",
    versionNumber: String(profile.version_number),
    aggregatorString: profile.aggregator_string || "=",
    rtp: rtpInputValue(profile.rtp)
});

export const profileDefaultsFormValues = profile => ({
    defaultSubsidiaries: (profile.subsidiary || []).map(
        subsidiary => subsidiary.id
    )
});

export const validateRTPProfile = (values: RTPProfileFormValues) => {
    const errors = {};
    const versionNumber = String(values.versionNumber).trim();
    const rtp = String(values.rtp).trim();

    if (!values.versionString.trim()) {
        errors["versionString"] = "Version String is required.";
    } else if (values.versionString.trim().length > 5) {
        errors["versionString"] = "Version String may contain up to 5 characters.";
    }

    if (!/^\d+$/.test(versionNumber)) {
        errors["versionNumber"] = "Version Number must be a non-negative integer.";
    }

    if (!values.aggregatorString.trim()) {
        errors["aggregatorString"] = "Aggregator is required.";
    } else if (values.aggregatorString.trim().length !== 1) {
        errors["aggregatorString"] = "Aggregator must be one character.";
    }

    if (!/^\d+$/.test(rtp) || Number(rtp) < 0 || Number(rtp) > 100) {
        errors["rtp"] = "RTP must be an integer between 0 and 100.";
    }

    return errors;
};

export const buildRTPProfilePayload = (
    values: RTPProfileFormValues
): RTPProfilePayload => ({
    version_string: values.versionString.trim(),
    version_number: Number(values.versionNumber),
    aggregator_string: values.aggregatorString.trim(),
    rtp: `${Number(values.rtp)}%`
});

export const defaultSubsidiaries = profile =>
    (profile.subsidiary || []).map(subsidiary =>
        subsidiary.description || subsidiary.name || `Subsidiary ${subsidiary.id}`
    );
